export default __webpack_public_path__ + "static/media/english-to-latvian-screenshot-02.ca54d9e5.png";